export const MAINTENANCE_MODE_FLAG = 'gxgo-maintenance-mode-enabled';
export const PERSONALIZATION_FLAG = 'gxgo-personalization-enabled';
export const GX_AI_FLAG = 'gxgo-ai-chat-enabled';
export const GX_PROMPT_SHARE = 'gxgo-ai-prompt-share-enabled';
